module.exports = __webpack_public_path__ + "img/4-(9).bda3574e.jpg";